import React from 'react'
import MainBanner from '../schedule/MainBanner';
import EventSchedulesFour from '../schedule/EventSchedulesFour';
import Footer from '../Common/Footer';
import LocalizedStrings from 'react-localization';
import localeFile from '../../local/content';

import {connect} from 'react-redux';
const strings = new LocalizedStrings(localeFile);
class ScheduleFour extends React.Component {
    render(){ strings.setLanguage(this.props.languageCode);
        return (
            <React.Fragment>
                <MainBanner />
                <EventSchedulesFour />
                <Footer />
            </React.Fragment>
        );
    }
}
 const mapStateToProps = state => {
    return {
      languageCode: state.languageCode
    }
  }
  
  export default connect(mapStateToProps)(ScheduleFour);